<h1 id="appTitle" class="hideText">Welcome Application {{ title }}</h1>

<router-outlet></router-outlet>
